<template>
  <component :is="tag" v-bind="binding" class="breadcrumb__item">
    <slot>{{ value.title || $tc('loading') + '...' }}</slot>
  </component>
</template>

<script>
import Dropdown from './Dropdown.vue'
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tag() {
      if (this.value.component) return this.value.component
      if (!this.value.title) return 'div'

      switch (typeof this.value.action) {
        case 'string':
          return 'a'
        case 'object':
          return 'router-link'
        default:
          return 'div'
      }
    },
    binding() {
      if (this.value.props) return this.value.props

      if (!this.value.title) return {}
      switch (typeof this.value.action) {
        case 'string':
          return { href: this.value.action }
        case 'object':
          return { to: this.value.action }
        default:
          return this.value.props || {}
      }
    },
  },
  components: {
    Dropdown,
  },
}
</script>

<style lang="scss">
.breadcrumb {
  &__item {
    text-decoration: none;
    color: inherit;
    cursor: default;

    &[href] {
      cursor: pointer;
      border-bottom: 1px solid css-darken('border-color', 15%);
    }
  }
}
</style>
